import * as React from "react";
import { DatePicker } from "../../../../../react-core/Datepicker/DatePicker";
import { MoneyDisplayHelper } from "../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PostCodeAnywhereSearchEditor } from "../../../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { MoneyTextBoxEditor } from "../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { RadiosEditor } from "../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PhysicalAddressTemplate } from "../../../../../Wrap/Constants/Enums/Domain/PhysicalAddressTemplate";
import { AccountRoleByActorDetails } from "../../../../../Wrap/Models/Domains/Account/AccountRoleByActorDetails";
import { RoleType } from "../../../../../Wrap/Constants/Enums/RoleType";
import { DeathDetails } from "../../../../../Wrap/Models/Models/Customer/DeathDetails";
import { EmploymentDetail } from "../../../../../Wrap/Models/Models/Customer/EmploymentDetail";
import { PersonalDetail } from "../../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../Shared/Entities/Constants/DateConstants";
import { CountryCodeMap } from "../../../../Shared/Entities/Maps/CountryCodeMap";
import { TitleMap } from "../../../../Shared/Entities/Maps/TitleMap";
import { SectionHeader, TrueFalseRadio } from "../NewBusinessWizard/Components/SharedComponents";
import {
    GenderOptions,
    GenderOptionsMap,
    Marital,
    CustomerStatuses,
    SourceOfWealthArray,
    SourceOfWealthArrayMap,
} from "../NewBusinessWizard/Resource/Contents";
import {
    EmploymentRole,
    IndividualEmploymentStatusOptions,
    IndividualEmploymentStatusOptionsMap,
} from "../NewQuoteWizard/Resource/Content";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import { SectionTable } from "./Components/SectionTable";
import {
    ClientRecordTab,
    IClientTabProps,
    OccupationIndustry,
    question,
    TrustMemberDeathValidationMsg,
} from "./Resource/Contents";
import { AccountRoleStore, ClientRecordStore } from "./Store/Variable";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../Shared/Permission/Permission";
import { CustomerStatus } from "../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { TrustMemberDeathValidationResult } from "../../../../../Wrap/Models/Models/Customer/TrustMemberDeathValidationResult";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { Alert } from "../../../../Shared/Components/Alert";
import { AlertType } from "../../../../Shared/Entities/Constants/AlertConstants";
import { CountryCode } from "../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Action } from "../../../Actions/Action";
import { SourceOfWealthType } from "../../../../../Wrap/Models/Models/Payments/SourceOfWealthType";

interface IPersonalDetailsState {
    personalDetail: PersonalDetail;
    accountRoleDetails: Array<AccountRoleByActorDetails>;
    employmentDetail: EmploymentDetail;
    deathDetail: DeathDetails;
    isPersonalDetailLoading: boolean;
    isRoleLoading: boolean;
    isEmploymentDetailLoading: boolean;
    isDeathDetailLoading: boolean;
    isCrownEmployeeOrArmedForceChanged: boolean;
    isLoadingDeathValidation: boolean;
    deathValidationResult: TrustMemberDeathValidationResult[];
    sourceOfWealthTypes: SourceOfWealthType[];
}

export class PersonalDetails extends FormComponent<IClientTabProps, IPersonalDetailsState> {
    constructor(props: IClientTabProps) {
        super(props);
        this.state = {
            personalDetail: null,
            accountRoleDetails: AccountRoleStore.getData()?.length > 0 ? AccountRoleStore.getData() : null,
            employmentDetail: null,
            deathDetail: null,
            isPersonalDetailLoading: true,
            isRoleLoading: true,
            isEmploymentDetailLoading: true,
            isDeathDetailLoading: true,
            isCrownEmployeeOrArmedForceChanged: false,
            isLoadingDeathValidation: false,
            deathValidationResult: [],
            sourceOfWealthTypes:[]
        };
        this.subscribeToStore(ClientRecordStore, () => this.onStoreChange());
        this.subscribeToStore(AccountRoleStore, () => this.onAccountRoleStoreChange());
    }

    private datePickerOptions = (hasValidate: boolean, particularDate?: Date, particularMessage?: string) => {
        return {
            showYearDropdown: true,
            todayButton: ContentDatePicker.Today,
            isClearable: true,
            atMost: hasValidate
                ? {
                    value: particularDate != null ? particularDate : new Date(),
                    errorMessage: particularMessage != null ? particularMessage : "Date can not be in the future",
                }
                : null,
            lessThan: null,
            dateFormat: ContentDatePicker.DateFormat,
            acceptDateFormats: ACCEPT_DATE_FORMATS,
            formGroupCssWrapper: "control-size-300",
        };
    };

    private futerDatePickerOptions = (hasValidate: boolean, particularDate?: Date, particularMessage?: string) => {
        return {
            showYearDropdown: true,
            todayButton: ContentDatePicker.Today,
            isClearable: true,
            atLeast:
                hasValidate && particularDate != null
                    ? {
                        value: particularDate != null ? particularDate : new Date("0001-01-01"),
                        errorMessage: particularDate != null ? particularMessage : "Date input is invalid",
                    }
                    : null,
            dateFormat: ContentDatePicker.DateFormat,
            acceptDateFormats: ACCEPT_DATE_FORMATS,
            formGroupCssWrapper: "control-size-300",
        };
    };

    private onStoreChange() {
        const data = ClientRecordStore.getData();
        if (data[ClientRecordTab.PersonalDetail]) {
            this.setState({ isPersonalDetailLoading: false, personalDetail: data[ClientRecordTab.PersonalDetail] });
        }
        if (data.EmploymentDetail) {
            this.setState({ isEmploymentDetailLoading: false, employmentDetail: data.EmploymentDetail });
        }
        if (data.DeathDetail) {
            this.setState({
                isDeathDetailLoading: false,
                deathDetail: data.DeathDetail,
            });
        }
    }

    private onAccountRoleStoreChange() {
        const data = AccountRoleStore.getData();
        if (data.length > 0) {
            this.setState({ accountRoleDetails: data });
        }
    }

    private getTextBySoWId(soWId) {
        return this.state.sourceOfWealthTypes.find(x => x.TypeId == soWId)?.TypeName ?? "";
    };

    componentDidMount() {
        ClientRecordAction.getEmploymentDetail(this.props.id);
        ClientRecordAction.getDeathDetail(this.props.id);
        this.checkTrustMemberDeathValidation();

        Action.getSourceOfWealthTypesModel((result) => {
            this.setState({ sourceOfWealthTypes: result.SourceOfWealthTypes })
        });
    }

    private onPersonalDetailSave(data) {
        if (this.isValid()) {
            this.setState({ isPersonalDetailLoading: true });
            ClientRecordAction.putPersonalDetail(data, this.props.id);
            return true;
        }
        return false;
    }

    private onEmploymentDetailSave(data) {
        if (this.isValid()) {
            this.setState({ isEmploymentDetailLoading: true });
            ClientRecordAction.putEmploymentDetail(data, this.props.id);
            return true;
        }
        return false;
    }

    private onDeathDetailSave(data) {
        if (
            this.state.deathValidationResult.length > 0 &&
            (this.state.deathValidationResult[0].IsLastFlexibleBeneficiary ||
                this.state.deathValidationResult[0].HasOutstandingRequests ||
                this.state.deathValidationResult[0].IsCorrespondence ||
                this.state.deathValidationResult[0].IsBeneficiaryNotWithZeroPercentage)
        ) {
            return false;
        } else {
            if (this.isValid()) {
                this.setState({ isDeathDetailLoading: true });
                ClientRecordAction.putDeathDetail(data, this.props.id, () => {
                    ClientRecordAction.getPersonalDetail(this.props.id);
                });
                return true;
            } else {
                return false;
            }
        }
    }

    private checkTrustMemberDeathValidation() {
        this.setState({ isLoadingDeathValidation: true });
        ClientRecordAction.getTrustMemberDeathValidation(this.props.id, (result) => {
            this.setState({ isLoadingDeathValidation: false, deathValidationResult: result });
        });
    }

    private getDeathDetailsColConfig(data: DeathDetails) {
        if (!data) {return [];}
        return [
            {
                title: "Death notification on",
                data: JsonDateParser.getFormatDate(data.NotificationDate, "dd/MM/yyyy"),
            },
            { title: "Death on", data: JsonDateParser.getFormatDate(data.DateOfDeath, "dd/MM/yyyy") },
            { title: "Probate on", data: JsonDateParser.getFormatDate(data.DateOfProbate, "dd/MM/yyyy") },
            {
                title: "Proof received on",
                data: JsonDateParser.getFormatDate(data.ProofOfDeathReceivedDate, "dd/MM/yyyy"),
            },
            { title: "Proof reference", data: data.ProofOfDeathReference },
        ];
    }

    private getPersonalDetailsColConfig(
        data: PersonalDetail,
        isCrownEmployeeOrArmedForce,
        role: Array<AccountRoleByActorDetails>
    ) {
        if (!data) {return [];}
        return [
            {
                title: "Full name",
                data: `${TitleMap.getString(data.Title)} ${data.GivenName} ${data.MiddleName || ""} ${data.FamilyName}`,
            },
            {
                title: "Customer status",
                data:
                    data.CustomerStatus == CustomerStatus.Inactive
                        ? "Inactive"
                        : role.length && !role.find((f) => f.AccountStatus.toLowerCase() == "inprogress")
                            ? CustomerStatuses.optionsMap[data.CustomerStatus]
                            : "Prospect",
            },
            { title: "Gender", data: GenderOptionsMap[data.Gender] },
            { title: "Marital status", data: Marital.optionsMap[data.MaritalStatus] },
            { title: "Date of birth", data: JsonDateParser.getFormatDate(data.DateOfBirth, "dd/MM/yyyy") },
            { title: "Town of birth", data: data.TownOfBirth },
            { title: "Country of birth", data: CountryCodeMap.getString(data.CountryOfBirth) },
            {
                title: "Is Crown Employee or Armed Forces?",
                data: isCrownEmployeeOrArmedForce
                    ? "Yes"
                    : isCrownEmployeeOrArmedForce == null || isCrownEmployeeOrArmedForce == undefined
                        ? null
                        : "No",
            },
            //removing this for now as requested due to Pensions not being built yet
            // {
            //     title: question.consent,
            //     data: "Yes",
            // },
        ];
    }

    private getEmploymentDetailColConfig(data: EmploymentDetail) {
        if (!data) {return [];}
        return [
            {
                title: "Employment status",
                data: IndividualEmploymentStatusOptionsMap[data.IndividualEmploymentStatus],
            },
            { title: "Employment role", data: data.Occupation },
            { title: "Occupation industry", data: data.BusinessCategory },
            { title: "Employer name", data: data.EmployerName },
            { title: "Country", data: CountryCodeMap.getString(data.EmployerAddress?.Country) },
            { title: "PostCode", data: data.EmployerAddress?.PostCode },
            { title: "Address line 1", data: data.EmployerAddress?.Address1 },
            { title: "Address line 2", data: data.EmployerAddress?.Address2 },
            { title: "Address line 3", data: data.EmployerAddress?.Address3 },
            { title: "Address line 4", data: data.EmployerAddress?.Address4 },
            {
                title: "Annual earnings",
                data:
                    data?.AnnualEarnings > 0
                        ? MoneyDisplayHelper.FromatMoneyDisplay(data.AnnualEarnings, data.AnnualEarningsCcy)
                        : null,
            },
            { title: "Length of service with this company", data: data.LengthOfService },
            { title: "Retirement Date", data: JsonDateParser.getFormatDate(data.RetirementDate, "dd/MM/yyyy") },
            {
                title: "Other proceeds",
                data: data?.OtherProceeds
                    ? MoneyDisplayHelper.FromatMoneyDisplay(Number(data.OtherProceeds), data.AnnualEarningsCcy)
                    : null,
            },
            {
                title: "Source of Wealth (Primary)",
                data: this.getTextBySoWId(data?.SourceOfWealthPrimary?.SourceOfWealthOption),
            },
            {
                title: "Country of Origin (Primary)",
                data: data?.CountryOfOriginPrimary > 0 ? CountryCodeMap.getString(data?.CountryOfOriginPrimary) : null,
            },
            {
                title: "Source of Wealth (Secondary)",
                data: this.getTextBySoWId(data?.SourceOfWealthSecondary?.SourceOfWealthOption),
            },
            {
                title: "Country of Origin (Secondary)",
                data:
                    data?.CountryOfOriginSecondary > 0
                        ? CountryCodeMap.getString(data?.CountryOfOriginSecondary)
                        : null,
            },
        ];
    }

    private onAddressChange(changes, originData, onDataChange) {
        const _data = originData
            ? JSON.parse(JSON.stringify(originData))
            : { PhysicalAddressTemplate: PhysicalAddressTemplate.StandardLifeDefault };
        for (const key in changes) {
            _data[key] = changes[key];
        }
        onDataChange({ EmployerAddress: _data });
    }

    private onIsCrownEmployeeOrArmedForceChange(change: boolean) {
        const { employmentDetail } = this.state;
        let _data = JSON.parse(JSON.stringify(employmentDetail ? employmentDetail : {}));
        if (!_data) {_data = {};}
        _data["IsCrownEmployeeOrArmedForce"] = change;
        this.setState({ isCrownEmployeeOrArmedForceChanged: true, employmentDetail: _data });
    }

    private renderEmploymentDetailLightBox(data, onDataChange) {
        return (
            <>
                <SelectEditor
                    options={IndividualEmploymentStatusOptions}
                    getText={(v) => IndividualEmploymentStatusOptionsMap[v]}
                    required={"Please select employment status"}
                    onChange={(v) => {
                        onDataChange({ IndividualEmploymentStatus: v });
                    }}
                    cssWrapper="control-size-300"
                    selected={data.IndividualEmploymentStatus}
                    label="Employment status"
                    placeholder="Please select"
                />
                <SelectEditor
                    options={EmploymentRole}
                    getText={(v) => v}
                    required={"Please select employment role"}
                    onChange={(v) => {
                        onDataChange({ Occupation: v });
                    }}
                    cssWrapper="control-size-300"
                    selected={data.Occupation}
                    label={"Employment role"}
                    placeholder="Please select"
                />
                <TextBoxEditor
                    label="Employer name"
                    cssWrapper="control-size-300"
                    onChange={(v) => {
                        onDataChange({ EmployerName: v });
                    }}
                    value={data.EmployerName}
                    maxLength={100}
                />
                <SelectEditor
                    options={OccupationIndustry}
                    getText={(v) => v}
                    required={"Please select occupation industry"}
                    onChange={(v) => {
                        onDataChange({ BusinessCategory: v });
                    }}
                    selected={data?.BusinessCategory}
                    label="Occupation industry"
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                />
                <SelectEditor
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    onChange={(v) => {
                        this.onAddressChange({ Country: v }, data.EmployerAddress, onDataChange);
                    }}
                    selected={data.EmployerAddress?.Country}
                    label="Country"
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                />
                <PostCodeAnywhereSearchEditor
                    onLookupError={() => { }}
                    onAddressSelected={(v) =>
                        this.onAddressChange(
                            {
                                Address1: v.Line1,
                                Address2: v.Line2,
                                Address3: v.Line3,
                                PostCode: v.Postcode,
                            },
                            data.EmployerAddress,
                            onDataChange
                        )
                    }
                    cssWrapper="control-size-300"
                    countryCode={data.EmployerAddress?.Country}
                    label={`Postcode`}
                />
                <TextBoxEditor
                    value={data.EmployerAddress?.Address1}
                    label={"Address line1"}
                    cssWrapper="control-size-300"
                    maxLength={50}
                    onChange={(v) => {
                        this.onAddressChange({ Address1: v }, data.EmployerAddress, onDataChange);
                    }}
                />
                <TextBoxEditor
                    value={data.EmployerAddress?.Address2}
                    label={"Address line2"}
                    cssWrapper="control-size-300"
                    maxLength={50}
                    onChange={(v) => {
                        this.onAddressChange({ Address2: v }, data.EmployerAddress, onDataChange);
                    }}
                />
                <TextBoxEditor
                    value={data.EmployerAddress?.Address3}
                    label={"Address line3"}
                    cssWrapper="control-size-300"
                    maxLength={35}
                    onChange={(v) => {
                        this.onAddressChange({ Address3: v }, data.EmployerAddress, onDataChange);
                    }}
                />
                <TextBoxEditor
                    value={data.EmployerAddress?.PostCode}
                    label={"Postcode"}
                    cssWrapper="control-size-300"
                    maxLength={8}
                    onChange={(v) => {
                        this.onAddressChange({ PostCode: v }, data.EmployerAddress, onDataChange);
                    }}
                />
                <MoneyTextBoxEditor
                    cssWrapper="control-size-300"
                    value={data.AnnualEarnings}
                    currency={data.AnnualEarningsCcy || CurrencyCode.GBP}
                    label="Annual earnings"
                    onChange={(v) =>
                        onDataChange({
                            AnnualEarnings: v,
                            AnnualEarningsCcy: data.AnnualEarningsCcy || CurrencyCode.GBP,
                        })
                    }
                />
                <TextBoxEditor
                    label="Length of service with this company"
                    cssWrapper="control-size-300"
                    onChange={(v) => {
                        onDataChange({ LengthOfService: v });
                    }}
                    value={data.LengthOfService}
                    maxLength={10}
                />
                <DatePicker
                    selected={JsonDateParser.toDateNoOffset(data.RetirementDate)}
                    label={"Retirement date"}
                    onChange={(v) => {
                        onDataChange({ RetirementDate: JsonDateParser.toJsonDateNoOffset(v) });
                    }}
                    {...this.datePickerOptions(false)}
                />
                <MoneyTextBoxEditor
                    label="Other proceeds"
                    cssWrapper="control-size-300"
                    currency={data.AnnualEarningsCcy || CurrencyCode.GBP}
                    onChange={(v) => {
                        onDataChange({ OtherProceeds: v });
                    }}
                    value={data.OtherProceeds}
                    maxLength={100}
                />

                {SectionHeader("Source Of Wealth")}
                <SelectEditor
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                    options={SourceOfWealthArray}
                    getText={(v) => this.getTextBySoWId(v)}
                    required={"Please select source of wealth (Primary)"}
                    onChange={(v) => {
                        onDataChange({ SourceOfWealthPrimary: { SourceOfWealthOption: v } });
                    }}
                    label={"Source of Wealth (Primary)"}
                    selected={data?.SourceOfWealthPrimary?.SourceOfWealthOption}
                    tooltip={"Specify the origin of the accumulated funds."}
                />

                <SelectEditor
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    required={"Please select country of origin (Primary)"}
                    onChange={(v) => {
                        onDataChange({ CountryOfOriginPrimary: v });
                    }}
                    label="Country of Origin (Primary)"
                    selected={data?.CountryOfOriginPrimary}
                />

                <SelectEditor
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                    options={SourceOfWealthArray}
                    getText={(v) => this.getTextBySoWId(v)}
                    onChange={(v) => {
                        onDataChange({ SourceOfWealthSecondary: { SourceOfWealthOption: v } });
                    }}
                    required={data?.CountryOfOriginSecondary
                        ? "Please select source of wealth (Secondary)" : ""}
                    label={"Source of Wealth (Secondary)"}
                    selected={data?.SourceOfWealthSecondary?.SourceOfWealthOption}
                    tooltip={"Specify the origin of the accumulated funds."}
                />

                <SelectEditor
                    cssWrapper="control-size-300"
                    placeholder="Please select"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    onChange={(v) => {
                        onDataChange({ CountryOfOriginSecondary: v });
                    }}
                    required={data?.SourceOfWealthSecondary?.SourceOfWealthOption
                        ? "Please select country of origin (Secondary)" : null}
                    label="Country of Origin (Secondary)"
                    selected={data?.CountryOfOriginSecondary}
                />
            </>
        );
    }

    private renderPersonalDetailLightBox(
        data,
        isCrownEmployeeOrArmedForce,
        actorRoleTypes,
        onDataChange,
        showContents
    ) {
        return (
            <>
                <SelectEditor
                    options={TitleMap.getArray()}
                    cssWrapper="control-size-300"
                    selected={data?.Title}
                    label={"Title"}
                    placeholder="Please select"
                    getText={(option) => TitleMap.getString(option)}
                    onChange={(value) => onDataChange({ Title: value })}
                    required={"Please select title"}
                />
                <TextBoxEditor
                    label="First name"
                    cssWrapper="control-size-300"
                    onChange={(v) => onDataChange({ GivenName: v })}
                    value={data.GivenName}
                    maxLength={100}
                    required={"Please enter first name"}
                />
                <TextBoxEditor
                    label="Surname"
                    cssWrapper="control-size-300"
                    onChange={(v) => onDataChange({ FamilyName: v })}
                    value={data.FamilyName}
                    maxLength={100}
                    required={"Please enter surname"}
                />
                <SelectEditor
                    options={CustomerStatuses.options}
                    cssWrapper="control-size-300"
                    getText={(v) => CustomerStatuses.optionsMap[v]}
                    onChange={(v) => {
                        onDataChange({ CustomerStatus: v });
                    }}
                    selected={Number(data.CustomerStatus)}
                    label="Customer status"
                    placeholder="No current status"
                    disabled={true}
                />
                <SelectEditor
                    cssWrapper="control-size-300"
                    options={GenderOptions}
                    getText={(v) => GenderOptionsMap[v]}
                    onChange={(v) => {
                        onDataChange({ Gender: v });
                    }}
                    selected={Number(data.Gender)}
                    label="Gender"
                    placeholder="Please select"
                    required={
                        actorRoleTypes?.includes(RoleType.IndividualAccountHolder) ||
                            actorRoleTypes?.includes(RoleType.LifeAssured) ||
                            actorRoleTypes?.includes(RoleType.Trustee) ||
                            actorRoleTypes?.includes(RoleType.Settlor)
                            ? "Please select gender"
                            : null
                    }
                />
                <SelectEditor
                    options={Marital.options}
                    cssWrapper="control-size-300"
                    getText={(v) => Marital.optionsMap[v]}
                    onChange={(v) => {
                        onDataChange({ MaritalStatus: v });
                    }}
                    selected={Number(data.MaritalStatus)}
                    label="Marital status"
                    placeholder="Please select"
                    required={
                        actorRoleTypes?.includes(RoleType.IndividualAccountHolder) ||
                            actorRoleTypes?.includes(RoleType.Trustee) ||
                            actorRoleTypes?.includes(RoleType.Settlor)
                            ? "Please select marital status"
                            : null
                    }
                />
                <DatePicker
                    selected={JsonDateParser.toDate(data.DateOfBirth)}
                    label={"Date of Birth"}
                    onChange={(v) => {
                        onDataChange({ DateOfBirth: JsonDateParser.toJsonDate(v) });
                    }}
                    required={
                        actorRoleTypes?.includes(RoleType.IndividualAccountHolder) ||
                            actorRoleTypes?.includes(RoleType.LifeAssured) ||
                            actorRoleTypes?.includes(RoleType.PowerOfAttorney) ||
                            actorRoleTypes?.includes(RoleType.LegalRepresentative) ||
                            actorRoleTypes?.includes(RoleType.Beneficiary) ||
                            actorRoleTypes?.includes(RoleType.Trustee) ||
                            actorRoleTypes?.includes(RoleType.TrustAppointer) ||
                            actorRoleTypes?.includes(RoleType.Settlor) ||
                            actorRoleTypes?.includes(RoleType.TrustProtector) ||
                            actorRoleTypes?.includes(RoleType.ControllingPerson)
                            ? "Please select date of birth"
                            : null
                    }
                    {...this.datePickerOptions(true)}
                />
                <TextBoxEditor
                    cssWrapper="control-size-300"
                    label="Town of birth"
                    onChange={(v) => {
                        onDataChange({ TownOfBirth: v });
                    }}
                    value={data.TownOfBirth}
                    maxLength={50}
                />
                <SelectEditor
                    cssWrapper="control-size-300"
                    options={CountryCodeMap.getArray(CountryCode.GBR)}
                    getText={(v) => CountryCodeMap.getString(v)}
                    required={"Please select country of birth"}
                    onChange={(v) => {
                        onDataChange({ CountryOfBirth: v });
                    }}
                    selected={data.CountryOfBirth}
                    label="Country of birth"
                    placeholder="Please select"
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Is crown employee or armed forces?"}
                    selected={isCrownEmployeeOrArmedForce}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : v == null || v == undefined ? null : "No")}
                    onChange={(v) => this.onIsCrownEmployeeOrArmedForceChange(v)}
                />
                {showContents && TrueFalseRadio(question.consent, "isVip", data, (key, v) => onDataChange({}))}
            </>
        );
    }

    private renderDeathDetailLightBox(data: DeathDetails, onDataChange) {
        if (this.state.isLoadingDeathValidation) {
            return <PartLoading isLoading={true} />;
        }
        const { deathValidationResult } = this.state;
        const correspondenceAccounts = deathValidationResult
            .filter((x) => x.IsCorrespondence)
            .map((x) => x.ClAccountId);
        const lastFlexibleBeneficiaryAccounts = deathValidationResult
            .filter((x) => x.IsLastFlexibleBeneficiary)
            .map((x) => x.ClAccountId);
        const accountsWithOutstandingRequests = deathValidationResult
            .filter((x) => x.HasOutstandingRequests)
            .map((x) => x.ClAccountId);
        const BeneficiaryWithZeroPercentageAccounts = deathValidationResult
            .filter((x) => x.IsBeneficiaryNotWithZeroPercentage)
            .map((x) => x.ClAccountId);
        return (
            <>
                {correspondenceAccounts.length != 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={correspondenceAccounts.join("; ") + TrustMemberDeathValidationMsg.correspondence}
                    />
                )}
                {lastFlexibleBeneficiaryAccounts.length != 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            lastFlexibleBeneficiaryAccounts.join("; ") +
                            TrustMemberDeathValidationMsg.lastFlexibleBeneficiary
                        }
                    />
                )}
                {accountsWithOutstandingRequests.length != 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            accountsWithOutstandingRequests.join("; ") +
                            TrustMemberDeathValidationMsg.hasOutstandingRequests
                        }
                    />
                )}
                {BeneficiaryWithZeroPercentageAccounts.length != 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            BeneficiaryWithZeroPercentageAccounts.join("; ") +
                            TrustMemberDeathValidationMsg.BeneficiaryWithZeroPercentage
                        }
                    />
                )}
                <DatePicker
                    selected={JsonDateParser.toDate(data.NotificationDate)}
                    label={"Death notification on"}
                    atMost={
                        JsonDateParser.toDate(data.NotificationDate)
                            ? { value: new Date(), errorMessage: ContentDatePicker.CannotBeInTheFuture }
                            : null
                    }
                    onChange={(v) => {
                        onDataChange({ NotificationDate: JsonDateParser.toJsonDate(v) });
                    }}
                    disabled={
                        correspondenceAccounts.length > 0 ||
                        lastFlexibleBeneficiaryAccounts.length > 0 ||
                        accountsWithOutstandingRequests.length > 0 ||
                        BeneficiaryWithZeroPercentageAccounts.length > 0
                    }
                    {...this.futerDatePickerOptions(
                        true,
                        JsonDateParser.toDate(data.DateOfDeath),
                        "Death notification date cannot be smaller than death date of " +
                        JsonDateParser.toDate(data.DateOfDeath)?.toDateString()
                    )}
                />

                {(data?.NotificationDate || data?.DateOfDeath) && (
                    <DatePicker
                        selected={JsonDateParser.toDate(data.DateOfDeath)}
                        label={"Death on"}
                        onChange={(v) => {
                            onDataChange({ DateOfDeath: JsonDateParser.toJsonDate(v) });
                        }}
                        disabled={
                            correspondenceAccounts.length > 0 ||
                            lastFlexibleBeneficiaryAccounts.length > 0 ||
                            BeneficiaryWithZeroPercentageAccounts.length > 0
                        }
                        {...this.datePickerOptions(
                            true,
                            JsonDateParser.toDate(data.NotificationDate),
                            "Date of death must be the same day or before the notification date" +
                            JsonDateParser.toDate(data.NotificationDate)?.toDateString()
                        )}
                    />
                )}
                {this.state.personalDetail?.CustomerStatus == CustomerStatus.Deceased && (
                    <>
                        <DatePicker
                            selected={JsonDateParser.toDateNoOffset(data.DateOfProbate)}
                            label={"Probate on"}
                            onChange={(v) => {
                                onDataChange({ DateOfProbate: JsonDateParser.toJsonDate(v) });
                            }}
                            {...this.datePickerOptions(true)}
                        />
                        <DatePicker
                            selected={JsonDateParser.toDateNoOffset(data.ProofOfDeathReceivedDate)}
                            label={"Proof received on"}
                            onChange={(v) => {
                                onDataChange({ ProofOfDeathReceivedDate: JsonDateParser.toJsonDate(v) });
                            }}
                            {...this.datePickerOptions(true)}
                        />
                        <TextBoxEditor
                            label="Proof reference"
                            onChange={(v) => {
                                onDataChange({ ProofOfDeathReference: v });
                            }}
                            cssWrapper="control-size-300"
                            value={data.ProofOfDeathReference}
                        />
                    </>
                )}
            </>
        );
    }

    render() {
        const {
            personalDetail,
            accountRoleDetails,
            employmentDetail,
            deathDetail,
            isPersonalDetailLoading,
            isEmploymentDetailLoading,
            isDeathDetailLoading,
            isRoleLoading,
        } = this.state;
        return (
            <div className="panel-subtle pl-34 pt-38">
                {
                    <>
                        <SectionTable
                            isLoading={isPersonalDetailLoading}
                            sectionHeader={"Personal details"}
                            columnConfigs={this.getPersonalDetailsColConfig(
                                personalDetail,
                                employmentDetail?.IsCrownEmployeeOrArmedForce,
                                accountRoleDetails || []
                            )}
                            lightboxContent={(data, onDataChange) =>
                                this.renderPersonalDetailLightBox(
                                    data,
                                    employmentDetail.IsCrownEmployeeOrArmedForce,
                                    accountRoleDetails?.map((x) => x.AccountRoleType),
                                    onDataChange,
                                    false
                                )
                            }
                            onSave={(data) => {
                                const personalDetailSaved = this.onPersonalDetailSave(data);
                                const employementDetailSaved = this.state.isCrownEmployeeOrArmedForceChanged
                                    ? this.onEmploymentDetailSave(employmentDetail)
                                    : true;
                                this.setState({ isCrownEmployeeOrArmedForceChanged: false });
                                return personalDetailSaved && employementDetailSaved;
                            }}
                            data={personalDetail}
                            sectionHeaderCss={"mb-40"}
                            cssWrapper={"mb-20"}
                            canEdit={this.props?.hasReadWriteAccess}
                        />
                        <SectionTable
                            isLoading={isEmploymentDetailLoading}
                            sectionHeader={"Employment details"}
                            columnConfigs={this.getEmploymentDetailColConfig(employmentDetail)}
                            lightboxContent={(data, onDataChange) =>
                                this.renderEmploymentDetailLightBox(data, onDataChange)
                            }
                            onSave={(data) => this.onEmploymentDetailSave(data)}
                            data={employmentDetail}
                            sectionHeaderCss={"mb-40"}
                            cssWrapper={"mb-20"}
                            canEdit={this.props?.hasReadWriteAccess}
                        />
                        <Permission userClaim={UserClaim.AdviserPortalCustomerFullyAccessCanView}>
                            <SectionTable
                                isLoading={isDeathDetailLoading}
                                sectionHeader={"Death details"}
                                columnConfigs={this.getDeathDetailsColConfig(deathDetail)}
                                lightboxContent={(data, onDataChange) =>
                                    this.renderDeathDetailLightBox(data, onDataChange)
                                }
                                onSave={(data) => this.onDeathDetailSave(data)}
                                data={deathDetail}
                                sectionHeaderCss={"mb-40"}
                                cssWrapper={"mb-20"}
                                canEdit={this.props?.hasReadWriteAccess}
                            />
                        </Permission>
                    </>
                }
            </div>
        );
    }
}
